import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from 'vue'

    interface IProps{
        amount?:number
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'AmountInput',
  props: {
    amount: {}
  },
  setup(__props: any) {

const props = __props;

    

    let num = ref('1')

    if(props.amount != null){
        num.value = props.amount.toString()
    }

    function plussAmount(){
        if(num.value === '1000') return
        num.value = (Number(num.value) + 1).toString()
    }

    function minusAmount(){
        if(num.value === '1') return
        num.value = (Number(num.value) - 1).toString()
    }

    function inputed(){
        if(Number(num.value) < 1) return '1'
        return num.value.replace(/[^0-9]$/g,'').slice(0,3)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => {minusAmount(); _ctx.$emit('selectedAmount', _unref(num))})
    }, _toDisplayString('<')),
    _withDirectives(_createElementVNode("input", {
      class: "amount-input",
      type: "text",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(num) ? (num).value = $event : num = $event)),
      onInput: _cache[2] || (_cache[2] = ($event: any) => {_isRef(num) //@ts-ignore
 ? num.value = inputed() : num = inputed(); _ctx.$emit('selectedAmount', _unref(num))})
    }, null, 544), [
      [_vModelText, _unref(num)]
    ]),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => {plussAmount(); _ctx.$emit('selectedAmount', _unref(num))})
    }, _toDisplayString('>'))
  ]))
}
}

})